import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const SpecialSession = () => {
  return (
    <React.Fragment>
      <SEO title="Special Sessions | ICSI 2023" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Special Sessions"
        content="For Authors"
        contentTwo="Special Sessions"
        linkage="/"

      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div className="entry-content">




          <h2 id="session1">
            Special Session 1: &quot;Machine Learning and Swarm Intelligence in Resource Allocation and Industrial Applications&quot;{" "}
            <p align="center">&nbsp;</p>
          </h2>
          <p>
            In the post COVID-19 era, both resource allocation in medical service and scheduling in industrial applications are facing new challenges, such as emergency or fluctuations in resource requirements. Moreover, with the rapid development of computation power and artificial intelligence, machine learning and swarm intelligence have become promising tools. Machine learning algorithms, such as the reinforcement learning algorithms, have shown strong ability in interactive learning environment. Swarm intelligence algorithms, inspired by the behavior in self-organized groups, such as birds, ants, bacteria, etc., hold the superiority in complex optimization problems. How to utilize swarm intelligence algorithms and machine learning algorithms to deal with problems in resource allocation and industrial applications remains to be an interesting topic and has attracted attentions from both researchers and engineers. {" "}
            <br />
            <br />
            The objective of this special session is to gather recent theoretical contributions in machine learning and swarm intelligence fields. And it also collects unpublished methods for practical problems in resource allocation and industrial applications.
          </p>
          <br></br>
          <p>
            <h3>Topics of Interest</h3>
          </p>
          <p>
            Research areas include, but are not limited to, the following
            topics:
            <ul>
              <li>
                Theoretical contributions in machine learning algorithms: reinforcement learning, deep learning, machine learning, meta-learning, etc;
              </li>
              <li>
                Unpublished ideas in swarm intelligence algorithms: particle swarm optimization, bacterial foraging optimization, genetic algorithm, hydrological cycle optimization, grey wolf optimization, artificial fish search algorithm, etc;
              </li>
              <li>
                Efficient methods for practical problems in resource allocation and industrial applications: intelligent resource allocation, intelligent transportation, medical dispatching, data mining, information systems, robotics, recommender systems, image processing, manufacturing system scheduling, etc;
              </li>
              <li>
                Original work towards multi-objective problems, multi-task problems and constrained problems;
              </li>
              <li>
                Other Intelligent Computing and Swarm Intelligence Related Algorithms and Applications.
              </li>
            </ul>
          </p>
          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2023 instruction for authors and submit your
            paper via the ICSI 2023 online submission system. Please specify
            that your paper is for &nbsp;
            <strong>
              &quot;SS1&quot; -- the Special Session on Machine Learning and Swarm Intelligence in Resource Allocation and Industrial Applications
            </strong>{" "}
            in your paper.
          </p>
          <p>
            <h3>Organizers</h3>
            <br></br>
            <table>
              <tr>
                <td>Name</td>
                <td>Affiliate</td>
                <td>Email</td>
              </tr>
              <tr>
                <td>Prof. Ben Niu</td>
                <td>Shenzhen University</td>
                <td>drniuben@gmail.com</td>
              </tr>
              <tr>
                <td>Dr. Tianwei Zhou</td>
                <td>Shenzhen University</td>
                <td>tianwei@szu.edu.cn</td>
              </tr>
              <tr>
                <td>Dr. Jing Liu</td>
                <td>University of New South Wales</td>
                <td>jing.liu5@unsw.edu.au</td>
              </tr>

            </table>
          </p>

          <p align="center">&nbsp;</p>
          <hr></hr>

          <p align="center">&nbsp;</p>
          <br></br>

          <h2 id="session2">
            Special Session 2: &quot;Fireworks Algorithm and Its Applications&quot;{" "}
            <p align="center">&nbsp;</p>
          </h2>
          <h3>Overview</h3>
          <br></br>
          <p>
            The Fireworks Algorithm is a new swarm intelligence optimization algorithm proposed in 2010 inspired by the phenomenon of fireworks explosions in the night sky. Fireworks algorithm has experienced extremely rapid development, mainly focusing on the research of single-objective optimization tasks in continuous space, and at the same time, attempts have been made in fields such as multi-objective optimization, parallel optimization framework, and optimization of large-scale optimization problems. The related research of the fireworks algorithm has received extensive attention from relevant scholars and engineering application personnel at home and abroad, and has achieved rich and remarkable achievements in both academic competitions and practical applications, which has greatly promoted the development of swarm intelligence algorithms.
            <br />
            <br />
            This special session aims at presenting the latest developments of
            the fireworks algorithm, as well as its new apllications and discussing
            the future directions of developmental fireworks algorithm. <br />
          </p>
          <br></br>
          <p>
            <h3>Topics of Interest</h3>
          </p>
          <p>
            Research areas include, but are not limited to, the following
            topics:
            <ul>
              <li>Theoretical research progress of fireworks algorithm, including time complexity theory, convergence theory, information utilization theory, etc.</li>
              <li>Recent development of fireworks algorithm.</li>
              <li>Research Progress and Application of Continuous Fireworks Algorithm.</li>
              <li>Research Progress and Application of Discrete Fireworks Algorithm.</li>
              <li>Application of Large-scale fireworks algorithm.</li>
            </ul>
          </p>
          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2023 instruction for authors and submit your
            paper via the ICSI 2023 online submission system. Please specify
            that your paper is for &nbsp;
            <strong>
              &quot;SS2&quot; -- the Special Session on Fireworks Algorithm and Its Applications
            </strong>{" "}
            in your paper.
          </p>
          <p>
            <h3>Organizers</h3>
            <br></br>
            <table>
              <tr>
                <td>Name</td>
                <td>Affiliate</td>
                <td>Email</td>
              </tr>
              <tr>
                <td>Dr. Shaoqiu Zheng</td>
                <td>The 28th Research Institute of China Electronics Technology Group Corporation</td>
                <td>zhengshaogiul214@foxmail.com</td>
              </tr>
              <tr>
                <td>Prof. Junqi Zhang </td>
                <td>Tongju University</td>
                <td>zhanghunqi@tongji.edu.cn</td>
              </tr>
              <tr>
                <td>Prof. Ying Tan</td>
                <td>Peking University</td>
                <td>ytan@pku.edu.cn</td>
              </tr>
            </table>
          </p>

          <br></br>
          <hr></hr>

          <br></br>


          <h2 id="session3">
            Special Session 3: &quot;Cooperative Decision and Control of Swarm Intelligence&quot;{" "}
            <p align="center">&nbsp;</p>
          </h2>
          <h3>Overview</h3>
          <p>
            The research on swarm intelligence is of great significance for promoting the development of a new generation of artificial intelligence. Wikipedia based on group editing, knowledge sharing based on public questions and answers, and open-source software based on group development represent that swarm intelligence is playing an increasingly important role in the information environment of the Internet of Things. Swarm intelligent decision and control methods mainly include knowledge-driven and data-driven, but each has its advantages and disadvantages. The collaborative drive of knowledge and data will provide new ideas and solutions for swarm intelligent decision-making. This special meeting aims to collect the latest progress in cooperative decision and control of swarm intelligence. We encourage high-quality original research papers and focus on methods to solve cooperative decision and control problems, including:
          </p>
          <p>
            <ul>
              <li>Machine learning systems for swarm intelligence</li>
              <li>Visual Collaboration in swarm intelligence</li>
              <li>Modelling, analysis, and simulation of intelligence system</li>
              <li>The perception and computing method of swarm intelligence </li>
              <li>Cooperative decision and control technology based on reinforcement learning</li>
              <li>Intelligent technology for data security</li>
            </ul>

          </p>
          <br />

          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2023 instruction for authors and submit your
            paper via the ICSI 2023 online submission system. Please specify
            that your paper is for &nbsp;
            <strong>
              &quot;SS3&quot; -- the Special Session on Cooperative Decision and Control of Swarm Intelligence
            </strong>{" "}
            in your paper.
          </p>
          <p>
            <h3>Organizers</h3>
            <br></br>
            <table>
              <tr>
                <td>Name</td>
                <td>Email</td>
              </tr>
              <tr>
                <td>Jiwei Zhang</td>
                <td>jwzhang666@bupt.edu.cn</td>
              </tr>
              <tr>
                <td>Lukun Wang</td>
                <td>wanglukun@gmail.com</td>
              </tr>
              <tr>
                <td>Ziyu Jia</td>
                <td>ziyujia@bjtu.edu.cn</td>
              </tr>
              <tr>
                <td>Feifei Kou</td>
                <td>koufeifei000@bupt.edu.cn</td>
              </tr>
            </table>
          </p>

          <p align="center">&nbsp;</p>
          <hr></hr>

          <p align="center">&nbsp;</p>



          <h2 id="session4">
            Special Session 4: &quot;Large-scale Global Optimization and Applications&quot;{" "}
            <p align="center">&nbsp;</p>
          </h2>
          <h3>Overview</h3>
          <p>
            With the rapid progress in technology and the explosive accumulation of data, a large number of large-scale   optimization problems have emerged in the fields of engineering design and scientific research. Although many  swarm intelligence algorithms have been developed to successfully solve small- and medium-scale optimization   problems, the search space of the problem exponentially expands as the dimension of the problem increases, which   results in a rapid deterioration of the performance of these optimization algorithms. Therefore, there is an urgent   requirement for the development of more effective and efficient swarm intelligence algorithms in the field of largescale global optimization to sufficiently explore the vast space with limited computational resources.
          </p>
          <p>
            <h3>Topics of Interest</h3>
          </p>
          <p>
            The objective of this special session is to collect the latest research advances in swarm intelligence for dealing with   large-scale global optimization problems. Research areas include, but are not limited to, the following topics:
          </p>


          <p>
            <ul>
              <li>Problem decomposition of large-scale optimization problems</li>
              <li>Computational resource allocation strategies in cooperative coevolution</li>
              <li>Novel swarm intelligence algorithms</li>
              <li>Hybridization and memetic algorithms</li>
              <li>Parallel swarm intelligence algorithms and distributed computing models.</li>
              <li>Theoretical and experimental analysis on the scalability of swarm intelligence</li>
              <li>Hardware implementation for large-scale optimization </li>
              <li>Real-world large-scale optimization applications</li>
            </ul>

          </p>
          <br />

          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2023 instruction for authors and submit your
            paper via the ICSI 2023 online submission system. Please specify
            that your paper is for &nbsp;
            <strong>
              &quot;SS4&quot; -- the Special Session on Large-scale Global Optimization and Applications
            </strong>{" "}
            in your paper.
          </p>
          <p>
            <h3>Organizers</h3>
            <br></br>
            <table>
              <tr>
                <td>Name</td>
                <td>Affiliate</td>
                <td>Email</td>
              </tr>
              <tr>
                <td>Dr. Peilan Xu</td>
                <td>Nanjing University of Information Science
                  and Technology</td>
                <td>xpl@nuist.edu.cn</td>
              </tr>
              <tr>
                <td>Dr. Wenjing Hong</td>
                <td>Southern University of Science and Technology</td>
                <td>hongwj@sustech.edu.cn</td>
              </tr>
              <tr>
                <td>Prof. Houjun Liang</td>
                <td>Anhui University of Finance and Economics</td>
                <td>lhj0013@126.com</td>
              </tr>
              <tr>
                <td>Prof. Wenjian Luo</td>
                <td>Harbin Institute of Technology, Shenzhen</td>
                <td>luowenjian@hit.edu.cn</td>
              </tr>
            </table>
          </p>

          <p align="center">&nbsp;</p>
          <hr></hr>

          <p align="center">&nbsp;</p>


          <h2 id="session5">
            Special Session 5: &quot;Biologically inspired Swarm Intelligence for Robotics and Mechatronics&quot;{" "}
            <p align="center">&nbsp;</p>
          </h2>
          <h3>Overview</h3>
          <p>
            Biologically inspired swarm intelligence technique, an important embranchment of series on computational intelligence, plays a crucial role for robotics. The autonomous robot and vehicle industry has had an immense impact on our economy and society, and this trend will continue with biologically inspired swarm intelligence techniques. Biologically inspired intelligence, such as biologically inspired neural networks (BINN), is about learning from nature, which can be applied to the real world robot and vehicle systems.  Recently, the research and development of bio-inspired systems for robotic applications is increasingly expanding worldwide.  Biologically inspired algorithms contain emerging sub-topics such as bio-inspired neural network algorithms, brain-inspired neural networks, swam intelligence with BINN, ant colony optimization algorithms (ACO) with BINN, bee colony optimization algorithms (BCO), particle swarm optimization with BINN, immune systems with BINN, and biologically inspired evolutionary optimization and algorithms, etc.  Additionally, it is decomposed of computational aspects of bio-inspired systems such as machine vision, pattern recognition for robot and vehicle systems, motion control, motion planning, movement control, sensor-motor coordination, and learning in biological systems for robot and vehicle systems. <br></br><br></br>
            This special session seeks to highlight and present the growing interests in emerging research, development and applications in the dynamic and exciting areas of biologically inspired algorithms for robot and vehicle systems (autonomous robots, unmanned underwater vehicles, and unmanned aerial vehicles).

          </p>
          <p>
            <h3>Topics of Interest</h3>
          </p>
          <p>
            Original research papers are solicited in related areas of biologically inspired algorithms for robotics. Submissions to the Special Session should be focused on theoretical results or innovative applications of computational intelligence of biologically inspired algorithms (such as BINN) for robot and vehicle systems.
            <br></br>
            Specific topics for the special session include but are not limited to:

          </p>


          <p>
            <ul>
              <li>Biologically inspired neural networks for robotics</li>
              <li>Deep neural networks and learning systems for robotics such as motion planning, navigation, mapping, localization, image processing, etc</li>
              <li>Bio-inspired system on computer vision and image progressing for robotics</li>
              <li>Human-like learning for robotics</li>
              <li>Theory, design, and applications of neural networks and related learning systems for robotics and vehicles</li>
              <li>Neuro-dynamics based models for robot and vehicle systems</li>
              <li>Evolutionary optimization, machine vision, pattern recognition for robot and vehicle systems</li>
              <li>Brain-inspired neural networks for robotics</li>
              <li>Swarm intelligence for robotics</li>
              <li>Evolutionary neuro-computing for robot and vehicle systems</li>
              <li>Bio-inspired system on machine learning, intelligent systems design for robotics</li>
              <li>Cellular automata for robotics</li>
              <li>Immune systems with BINN for robotics</li>
              <li>Ant colony optimization algorithms (ACO) with BINN for robotics</li>
              <li>Bee colony optimization algorithms (BCO) with BINN for robotics.</li>
            </ul>

          </p>
          <br />

          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2023 instruction for authors and submit your
            paper via the ICSI 2023 online submission system. Please specify
            that your paper is for &nbsp;
            <strong>
              &quot;SS5&quot; -- the Special Session on Biologically inspired Swarm Intelligence for Robotics and Mechatronics
            </strong>{" "}
            in your paper.
          </p>
          <p>
            <h3>Organizers</h3>
            <br></br>
            <table>
              <tr>
                <td>Name</td>
                <td>Affiliate</td>
                <td>Email</td>
              </tr>
              <tr>
                <td>Dr. Chaomin Luo</td>
                <td>Mississippi State University, Mississippi State, MS, 39762, USA</td>
                <td>Chaomin.Luo@ece.msstate.edu</td>
              </tr>
              <tr>
                <td>Dr. Gene Eu Jan</td>
                <td>National Taipei University, and Tainan National University of the Arts</td>
                <td>Gejan@mail.ntpu.edu.tw</td>
              </tr>
            </table>
          </p>

          <p align="center">&nbsp;</p>
          <hr></hr>
          <p align="center">&nbsp;</p>



          <h2 id="session6">
            Special Session 6: &quot;Swarm Intelligence in Dynamic Optimization&quot;{" "}
            <p align="center">&nbsp;</p>
          </h2>
          <h3>Overview</h3>
          <p>
            There are many dynamic optimization problems in real-world applications, whose objectives and/or constraints   change over time. These problems, known as dynamic optimization problems, bring a great challenge for   traditional swarm intelligence, which are designed to handle static optimization problems and struggle to adapt to   the changing environments. To effectively solve dynamic optimization problems, novel swarm intelligence   algorithms with efficient dynamic response strategies, which can quickly adapt to changing environment, are   needed. Studies in dynamic optimization are crucial to improve the cost-effectiveness of decision making in   dynamic environments.

          </p>
          <p>
            <h3>Topics of Interest</h3>
          </p>
          <p>
            The goal of this special session is to bring together researchers and practitioners working on dynamic optimization to share their latest work and opinions. The topics of interest include, but are not limited to:
          </p>


          <p>
            <ul>
              <li>Environment change detection strategy.</li>
              <li>Dynamic response strategy.</li>
              <li>Novel evolutionary algorithms and swarm intelligence for dynamic optimization.</li>
              <li>Designing hybrid algorithms for dynamic optimization.</li>
              <li>High-dimensional evolutionary dynamic optimization algorithms.</li>
              <li>Benchmark suites for dynamic optimization.</li>
              <li>Exploring the use of evolutionary dynamic optimization algorithms in real-world optimization applications.</li>
            </ul>

          </p>
          <br />

          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2023 instruction for authors and submit your
            paper via the ICSI 2023 online submission system. Please specify
            that your paper is for &nbsp;
            <strong>
              &quot;SS6&quot; -- the Special Session on Biologically inspired Swarm Intelligence for Robotics and Mechatronics
            </strong>{" "}
            in your paper.
          </p>
          <p>
            <h3>Organizers</h3>
            <br></br>
            <table>
              <tr>
                <td>Name</td>
                <td>Affiliate</td>
                <td>Email</td>
              </tr>
              <tr>
                <td>Xin Lin </td>
                <td>Nanjing University of Information Science and Technology</td>
                <td>xlin@nuist.edu.cn</td>
              </tr>
              <tr>
                <td>Chenyang Bu </td>
                <td>Hefei University of Technology </td>
                <td>chenyangbu@hfut.edu.cn</td>
              </tr>
              <tr>
                <td>Tao Zhu </td>
                <td>University of South China </td>
                <td>tzhu@usc.edu.cn</td>
              </tr>
              <tr>
                <td>Wenjian Luo </td>
                <td>Harbin Institute of Technology, Shenzhen </td>
                <td>luowenjian@hit.edu.cn</td>
              </tr>
            </table>
          </p>

          <p align="center">&nbsp;</p>
          <p align="center">&nbsp;</p>


          <h2 id="session7">
            Special Session 7: &quot;Intelligent Decision Making in Real life applications using nature inspired optimization techniques&quot;{" "}
            <p align="center">&nbsp;</p>
          </h2>
          <h3>Overview</h3>
          <p>
            In most of real life applications, intelligent decision making is a vital factor for obtaining the
            favorable and best outcomes. Nature inspired optimization techniques due to its highly functioning
            mechanism leads to make the best use of limited resources. In every domain of industry,
            pharmaceuticals, Finance, marketing, production, intelligent decision making is the need of this
            hour. Using limited resources, finding best alternative using nature inspired optimization
            techniques is the theme of this session which has attracted attention from many researchers and
            academicians. The objective of this special session is to attract the unpublished work in areas of
            nature inspired optimization techniques and its real life problems.


          </p>
          <p>
            <h3>Topics of Interest</h3>
          </p>
          <p>
            The research topics, but not limited to are covered in this special session:
          </p>
          <p>
            <ul>
              <li>Development and modification of existing Nature Inspired optimization Techniques.</li>
              <li>Proposing novel nature inspired optimization techniques</li>
              <li>Application of nature inspired algorithm in real life problems.</li>
            </ul>
          </p>


          <br />

          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2023 instruction for authors and submit your
            paper via the ICSI 2023 online submission system. Please specify
            that your paper is for &nbsp;
            <strong>
              &quot;SS7&quot; -- the Special Session on Intelligent Decision Making in Real life applications using nature inspired optimization techniques
            </strong>{" "}
            in your paper.
          </p>
          <p>
            <h3>Organizers</h3>
            <br></br>
            <table>
              <tr>
                <td>Name</td>
                <td>Affiliate</td>
                <td>Email</td>
              </tr>
              <tr>
                <td>Dr. Vanita Garg</td>
                <td>Galgotias University</td>
                <td>vanitagarg16@gmail.com</td>
              </tr>
              <tr>
                <td>Prof. Kusum Deep </td>
                <td>Indian Institute of Technology Roorkee</td>
                <td>kusumdeep@gmail.com</td>
              </tr>
              <tr>
                <td>Prof. Andries P. Engelbrecht</td>
                <td>Stellenbosch University, Stellenbosch, South Africa</td>
                <td>engel@sun.ac.za</td>
              </tr>
              {/* <tr>
                <td>Wenjian Luo </td>
                <td>Harbin Institute of Technology, Shenzhen </td>
                <td>luowenjian@hit.edu.cn</td>
              </tr> */}
            </table>
          </p>

          <p align="center">&nbsp;</p>
          <p align="center">&nbsp;</p>


          <h2 id="session8">
            Special Session 8: &quot;Natural-inspired Adaptive Optimization Algorithms: New Theory, New Local Structures, New Evolutionary Strategies, and New Applications&quot;{" "}
            <p align="center">&nbsp;</p>
          </h2>
          <h3>Rationale of the need for the special session at ICSI</h3>
          <p>The rationale should stress the novelty of the topic and/or its multidisciplinary flavor, and must explain how it is different from the subjects covered by the regular sessions.
          </p>

          <p>
            <ul>
              <li>The need to stay current with new theoretical developments in natural-inspired optimization algorithms: As research in the field of natural-inspired optimization algorithms continues to evolve, it is important to stay current with new developments in order to fully understand the capabilities and limitations of these algorithms.</li>
              <li>The potential of new local structures, new evolutionary strategies, and other new developments to improve the performance of natural-inspired optimization algorithms: New developments in local structures and evolutionary strategies can help to improve the performance of natural-inspired optimization algorithms, making them more efficient and effective in solving complex optimization problems.</li>
              <li>The need to explore new applications of natural-inspired optimization algorithms: As new applications of natural-inspired optimization algorithms are being discovered, it is important to explore these new areas to fully understand the potential of these algorithms and how they can be applied in practice.</li>
              <li>To keep up with the cutting-edge of the field: The special session will address the recent developments and advancements in the field of natural-inspired optimization algorithms and how it can be applied in different fields, providing a valuable contribution to the swarm intelligence conference.</li>
              <li>This special session is more specific and in-depth in the sense that it is entirely focused on natural-inspired adaptive optimization algorithms and its new developments, providing an opportunity for researchers to present their most recent results and discoveries in this field. Additionally, it also aims to explore new applications of natural-inspired optimization algorithms that may not be covered in regular sessions of ICSI.</li>
              <li>The special session is also different as it is a focused platform for researchers and practitioners to share their knowledge, ideas, and experiences on the application of natural-inspired optimization algorithms in various fields, fostering collaboration and knowledge sharing.</li>
            </ul>
          </p>


          <p>
            <h3>Topics of Interest</h3>
          </p>
          <p>
            Potential topics for papers within the special session could include but not limited to:
          </p>
          <p>
            <ul>
              <li>New theory of natural-inspired adaptive optimization algorithms</li>
              <li>New local structures of natural-inspired adaptive optimization algorithms such as niching, island models, and speciation, to improve the performance of natural-inspired optimization algorithms</li>
              <li>New evolutionary strategies of natural-inspired adaptive optimization algorithms, such as coevolution, memetic algorithms, and multi-objective optimization, and their potential to improve the performance of natural-inspired optimization algorithms</li>
              <li>New applications of natural-inspired adaptive optimization algorithms. Applying new natural inspired optimization algorithms to specific fields and applications, such as robot path planning, intelligent building energy saving measures, optimization of complex systems, et al.</li>
            </ul>
          </p>


          <br />

          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2023 instruction for authors and submit your
            paper via the ICSI 2023 online submission system. Please specify
            that your paper is for &nbsp;
            <strong>
              &quot;SS8&quot; -- the Special Session on Natural-inspired Adaptive Optimization Algorithms: New Theory, New Local Structures, New Evolutionary Strategies, and New Applications
            </strong>{" "}
            in your paper.
          </p>
          <p>
            <h3>Organizers</h3>
            <br></br>
            <table>
              <tr>
                <td>Name</td>
                <td>Affiliate</td>
                <td>Email</td>
              </tr>
              <tr>
                <td>Dr. Jia Guo</td>
                <td>Hubei University of Economics</td>
                <td>guojia314@gmail.com</td>
              </tr>
              <tr>
                <td>Prof. Yuji Sato</td>
                <td>Hosei University, Japan</td>
                <td>yuji@hosei.ac.jp</td>
                <td></td>
              </tr>
              <tr>
                <td>Prof. Zhiwei Ye</td>
                <td>Hubei University of Technology</td>
                <td>hgcsyzw@mail.hbut.edu.cn</td>
              </tr>
              <tr>
                <td>Dr. Yun Bai</td>
                <td>China Construction Third Engineering Bureau Information Technology Research Institute</td>
                <td>bai_yun@cscec.com</td>
              </tr>

            </table>
          </p>

          <p align="center">&nbsp;</p>



          <hr></hr>

          <p align="center">&nbsp;</p>

          <div className="call-sp">
            <h2>ICSI 2023 Call for Special Session Proposals</h2>
            <br></br>
            <p align="justify">
              ICSI 2023 technical program will include special sessions. Their aim
              is to provide a complementary flavor to the regular sessions and
              should include hot topics of interest to the swarm intelligence
              community that may also go beyond disciplines traditionally
              represented at ICSI.
            </p>
            <p align="justify">
              Prospective organizers of special sessions should submit proposals
              indicating:
            </p>
            <p align="left">
              * Title of the session.
              <br />
              * Rationale of the need for the special session at ICSI.
              <br />
              <em>
                The rationale should stress the novelty of the topic and/or its
                multidisciplinary flavor, and must explain how it is different
                from the subjects covered by the regular sessions.
              </em>
              <br />
              * Short biography of the organizers.
              <br />* List of 5 – 6 contributed papers (including titles, authors,
              contact information of the corresponding author){" "}
              <em>
                (this can also be provided later when they become available).
              </em>
            </p>
            <p align="justify">
              Proposals are due on or before January 15, 2023 and should be sent
              via e-mail (in either pdf or plain ASCII text form) to the special
              sessions chair (to be announced) and forward to ICSI 2023
              secretariat at
              <a href="mailto:icsi2023@iasei.org">icsi2023@iasei.org</a>.
            </p>
            <p align="justify">
              Proposals will be evaluated based on the timeliness of the topic,
              the qualifications of the organizers and the authors of the papers
              proposed in the session. In its decision, the committee will try to
              realize a balance of the topics across the technical areas
              represented in swarm intelligence.
            </p>
            <p align="justify">
              Notification of acceptance will be sent to the organizers no later
              than January 15, 2023. Authors of papers included in approved
              special sessions should submit their manuscript on or before January
              30, 2023. Manuscripts should conform to the formatting and
              electronic submission guidelines of regular ICSI papers (Springer’s
              LNCS format).
            </p>
            <p>
              When they submit papers, there is a choice to indicate that their
              papers are special session papers which will also undergo peer
              review. It is the responsibility of the organizers to ensure that
              their special session meets the ICSI quality standards. If, at the
              end of the review process, less than four papers are accepted, the
              session will be canceled and the accepted papers will be moved to
              regular sessions.
            </p>
          </div>

          <br /><br />
          <hr></hr>
          <br /><br />





        </div>
      </EmptyTwo>
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default SpecialSession;
